export default __webpack_public_path__ + "static/vueJSbarcelona_logo-9387f03db18fb5121d9a4d5c282766bc.svg";